import { io } from "socket.io-client";
import keycloak from "../keycloack";
import getEnv from "../config";

// Flask-SocketIO on tim serves the default path; REACT_APP_API_URL points at tim's root.
const SOCKET_PATH = "/socket.io";

/**
 * Open a Socket.IO connection to tim. The Keycloak token is sent on every
 * (re)connect so tim can put this browser in its own user room and deliver
 * only that user's live updates. Returns null when no API URL is configured.
 */
export function createSocket() {
  const baseURL = getEnv("REACT_APP_API_URL");
  if (!baseURL) return null;
  return io(baseURL, {
    transports: ["websocket", "polling"],
    path: SOCKET_PATH,
    auth: (cb) => cb({ token: keycloak?.token }),
  });
}
